import * as S from "./styles.ts";
import Category, { TCategory } from "./Category";

export interface ILinkCategoriesProps {
  categories: TCategory[];
  availableTrial?: boolean;
  altStyling?: boolean;
}

const LinkCategories = ({
  categories,
  availableTrial,
  altStyling,
}: ILinkCategoriesProps) => {
  return (
    <S.LinkCategoriesContainer>
      {categories.map((category, i) => (
        <Category
          category={category}
          key={i}
          availableTrial={availableTrial}
          altStyling={altStyling}
        />
      ))}
    </S.LinkCategoriesContainer>
  );
};

export default LinkCategories;
